import { useScrollAnimation } from '@/hooks/useScrollAnimation';

export default function CoreValuesSection() {
  const ref = useScrollAnimation<HTMLDivElement>();

  const items = [
    {
      title: '야외 벙커 연습장 완비',
      desc: '필드에서 가장 두려운 벙커 샷, 이제 GF의 실제 야외 벙커 연습장에서 연습하며 벙커 악몽을 완벽하게 탈출해 보세요.',
    },
    {
      title: '10~15m 규모의 탁 트인 야외 퍼팅장',
      desc: '답답한 실내를 벗어나 뻥 뚫린 스케일의 야외 퍼팅장에서 거리감을 익힐 수 있습니다.',
    },
    {
      title: '정교한 어프로치 연습',
      desc: '퍼팅뿐만 아니라 필드 스코어를 좌우하는 짧은 어프로치 샷까지 실전처럼 완벽하게 트레이닝할 수 있는 최적의 공간입니다.',
    },
  ];

  return (
    <section ref={ref} className="scroll-animate py-16 md:py-24 px-4 md:px-6 bg-cream">
      <div className="max-w-6xl mx-auto flex flex-col items-center gap-10 md:gap-16">
        <div className="text-center">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4 leading-tight">
            숏게임과 벙커 탈출까지 완벽하게,
            <br className="hidden md:block" />
            실전을 대비하는 야외 특별 연습장
          </h2>
          <div className="w-16 h-1 bg-accent mb-6 mx-auto" />
        </div>

        <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          <div className="w-full h-[300px] md:h-[400px] rounded-lg overflow-hidden bg-gray-100">
            <img
              src="/media/img13.jpg"
              alt="천안GF골프연습장 야외 벙커 연습장"
              className="w-full h-full object-contain"
            />
          </div>
          <div className="w-full h-[300px] md:h-[400px] rounded-lg overflow-hidden bg-gray-100">
            <img
              src="/media/img14.jpg"
              alt="천안GF골프연습장 야외 퍼팅장"
              className="w-full h-full object-contain"
            />
          </div>
        </div>

        <div className="w-full grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {items.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-lg p-6 md:p-8 border-l-4 border-accent"
            >
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3">
                {item.title}
              </h3>
              <p className="text-base md:text-lg text-gray-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}